'use client';
import * as React from "react";
const defaultContextValue = false;
export const DialogSurfaceContext = React.createContext(undefined);
export const DialogSurfaceProvider = DialogSurfaceContext.Provider;
export const useDialogSurfaceContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(DialogSurfaceContext)) !== null && _React_useContext !== void 0 ? _React_useContext : defaultContextValue;
};
